import {
  isReviewInBulkEnabled,
  useFeatureFlag
} from '@/application/use-feature-flag'
import { useAppSelector } from '@/redux/hooks'
import { Base } from '@itsrever/design-system'
import { useTranslation } from 'react-i18next'

const { Button } = Base

export const BulkReviewButton = () => {
  const { t } = useTranslation()

  const user = useAppSelector((state) => state.userApi.getMe.response.user)

  const { isFlagEnabled } = useFeatureFlag(isReviewInBulkEnabled, {
    userGroup: user?.group
  })

  if (!isFlagEnabled) {
    return null
  }

  return (
    <Button variant="secondary">
      <a
        href={`https://form.typeform.com/to/JggheR52?user=${user?.name}`}
        target="_blank"
        rel="noopener noreferrer"
        className="flex gap-1.5"
      >
        <svg
          stroke="currentColor"
          fill="none"
          strokeWidth="2"
          viewBox="0 0 24 24"
          strokeLinecap="round"
          strokeLinejoin="round"
          height="20"
          width="20"
          xmlns="http://www.w3.org/2000/svg"
          className="text-neutral-600"
        >
          <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2"></path>
          <path d="M7 9l5 -5l5 5"></path>
          <path d="M12 4l0 12"></path>
        </svg>
        {t('items.review_bulk')}
      </a>
    </Button>
  )
}
